import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../img/Boston_University.png'
import _imports_1 from '../img/York_University.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-579b3049"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about" }
const _hoisted_2 = {
  class: "module",
  id: "education"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { id: "bu" }
const _hoisted_5 = { class: "university" }
const _hoisted_6 = { class: "university_combo" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "BU-Logo"
}, null, -1))
const _hoisted_8 = { class: "school_address" }
const _hoisted_9 = {
  href: "https://www.bu.edu/",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_10 = { class: "related-course" }
const _hoisted_11 = { id: "york" }
const _hoisted_12 = { class: "university" }
const _hoisted_13 = { class: "university_combo" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "York-Logo"
}, null, -1))
const _hoisted_15 = { class: "school_address" }
const _hoisted_16 = {
  href: "https://www.yorku.ca",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_17 = { class: "related-course" }
const _hoisted_18 = {
  class: "module",
  id: "skills"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Html, CSS, JavaScript, Vue.js, Ajax, Element", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Java, Kotlin, R, Spring, SpringMVC, Spring Boot, MyBatis, Tomcat, JWT, Filter, Interceptor", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "MySQL, Redis, FireBase", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "IntelliJ, VS Code, GitHub, Android Studio, Rstudio, ApiFox, Postman, Swagger, Figma ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "leetcard" }, null, -1))
const _hoisted_25 = {
  class: "module",
  id: "self-introduction"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_27 = { id: "left-aligned" }
const _hoisted_28 = {
  class: "module",
  id: "github"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_30 = { class: "clearfix" }
const _hoisted_31 = { style: {"margin-top":"10px"} }
const _hoisted_32 = {
  class: "module",
  id: "resume"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_34 = { id: "download_resume" }

import '../css/AboutViewCss.css';
import { ref, onMounted } from 'vue';
import axios from 'axios';


interface GitHubProject {
  id: number;
  name: string;
  html_url: string;
  description: string;
  language: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AboutView',
  setup(__props) {

const fetchLeetCard = () => {
  axios.get('https://leetcard.jacoblin.cool/liu-ying-chen?theme=nord&font=Poppins&ext=heatmap&site=cn')
    .then(response => {
      const svgData = response.data;
      const element = document.getElementById('leetcard');
      if (element !== null) {
        element.innerHTML = svgData;
      }
    })
    .catch(error => {
      console.error('Error fetching the SVG:', error);
    });
};

//GitHub function
const projects = ref<GitHubProject[]>([]);

const fetchGitHubProjects = async () => {
  try {
    const response = await axios.get('https://api.github.com/users/YingChenLiu18/repos');
    projects.value = response.data;
  } catch (err) {
    console.error('Error fetching GitHub projects:', err);
  }
};

const openLink = (url: string) => {
  window.open(url, '_blank');
};

//Resume function
const dialogVisible = ref(false);

const openDialog = () => {
  dialogVisible.value = true;
};

const downloadResume = async (lang: string) => {
  const resumeUrl = lang === 'zh'
    ? '/api/YingChenLiu-Resume-C.pdf'
    : '/api/YingChenLiu-Resume-E.pdf';

  try {
    const response = await axios.get(resumeUrl, {
      responseType: 'blob'
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', lang === 'zh' ? '简历_中文.pdf' : 'Resume_English.pdf');
    document.body.appendChild(link);
    link.click();
    link.remove();
    dialogVisible.value = false;
  } catch (error) {
    console.error('Error downloading resume:', error);
  }
};

onMounted(() => {
  fetchGitHubProjects();
  fetchLeetCard();
});

return (_ctx: any,_cache: any) => {
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('AboutView.education')), 1),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('AboutView.master')), 1),
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('AboutView.masterDate')), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h4", null, [
                _createElementVNode("a", _hoisted_9, _toDisplayString(_ctx.$t('AboutView.bostonUniversity')), 1)
              ]),
              _createElementVNode("h4", null, _toDisplayString(_ctx.$t('AboutView.bostonUniversityAddress')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t('AboutView.relatedCourse')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('AboutView.bostonCourse')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", null, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('AboutView.bachelor')), 1),
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('AboutView.bachelorDate')), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("h4", null, [
                _createElementVNode("a", _hoisted_16, _toDisplayString(_ctx.$t('AboutView.yorkUniversity')), 1)
              ]),
              _createElementVNode("h4", null, _toDisplayString(_ctx.$t('AboutView.yorkUniversityAddress')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t('AboutView.relatedCourse')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('AboutView.yorkCourse')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('AboutView.skills')), 1),
      _hoisted_19,
      _createElementVNode("h5", null, _toDisplayString(_ctx.$t('AboutView.frontEnd')), 1),
      _hoisted_20,
      _createElementVNode("h5", null, _toDisplayString(_ctx.$t('AboutView.backEnd')), 1),
      _hoisted_21,
      _createElementVNode("h5", null, _toDisplayString(_ctx.$t('AboutView.database')), 1),
      _hoisted_22,
      _createElementVNode("h5", null, _toDisplayString(_ctx.$t('AboutView.cloudService')), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('AboutView.aliyunOss')), 1),
      _createElementVNode("h5", null, _toDisplayString(_ctx.$t('AboutView.developmentTool')), 1),
      _hoisted_23,
      _createElementVNode("h5", null, _toDisplayString(_ctx.$t('AboutView.dataStructures')), 1),
      _createVNode(_component_el_link, {
        href: "https://leetcode.cn/u/liu-ying-chen/",
        target: "_blank",
        style: {"margin-bottom":"10px"}
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('AboutView.leetcodeLink')), 1)
        ]),
        _: 1
      }),
      _hoisted_24,
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('AboutView.algorithmList')), 1)
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('AboutView.selfIntroduction')), 1),
      _hoisted_26,
      _createElementVNode("ul", _hoisted_27, [
        _createElementVNode("li", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('AboutView.deepProgramming')), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('AboutView.deepProgrammingText')), 1)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('AboutView.excellentCode')), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('AboutView.excellentCodeText')), 1)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('AboutView.attentionToDetail')), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('AboutView.attentionToDetailText')), 1)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('AboutView.selfDirected')), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('AboutView.selfDirectedText')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('AboutView.githubProjects')), 1),
      _hoisted_29,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projects.value, (project) => {
        return (_openBlock(), _createElementBlock("div", {
          key: project.id,
          style: {"margin-bottom":"20px"}
        }, [
          _createVNode(_component_el_card, { class: "box-card" }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_el_link, {
                  underline: true,
                  onClick: _withModifiers(() => openLink(project.html_url), ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(project.name), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(project.description), 1),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_el_tag, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(project.language), 1)
                  ]),
                  _: 2
                }, 1024)
              ])
            ]),
            _: 2
          }, 1024)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('AboutView.resume')), 1),
      _hoisted_33,
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: openDialog
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('AboutView.downloadResume')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogVisible).value = $event)),
        title: _ctx.$t('AboutView.chooseResumeLanguage')
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('AboutView.selectResumeLanguage')), 1),
          _createElementVNode("div", _hoisted_34, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (downloadResume('zh')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('AboutView.downloadResumeZh')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (downloadResume('en')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('AboutView.downloadResumeEn')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ])
  ]))
}
}

})